import * as React from "react";

// import { SpsButton } from "@spscommerce/ui-react";
// import { $IdentityResource } from 'app/resources';
import { SpsNotificationDropdown } from "./SpsNotificationDropdown";
import { $CurrentUser } from "../../classes/current.user/current.user";

import axios from "axios";
import "./SpsNotification.scss";

const mnaUrlMap = {
    local: "https://api.mna.dev.spsapps.net",
    dev: "https://api.mna.dev.spsapps.net",
    test: "https://api.mna.test.spsapps.net",
    stage: "https://api.mna.stage.spsapps.net",
    prod: "https://api.mna.spsapps.net"
};
const MINUTE = 60 * 1000;
// 30 second interval
const INTERVAL = MINUTE / 2;
// extended 5 minute interval
const EXTENDED_INTERVAL = 5 * MINUTE;
const PAGE_SIZE = 25;

function updateNotifications(newNotifications, previousNotifications) {
    // append the new notifications and drop the same number from the end of the list
    const shortenedNotifications = previousNotifications.slice(
        newNotifications.length
    );
    return [...newNotifications, ...shortenedNotifications];
}

export default function SpsNotification(props) {
    const [webNotifications, setWebNotifications] = React.useState([]);
    // we will fetch this number from the new endpoint
    const [unreadMessages, setUnreadMessages] = React.useState(0);
    const [errorState, setErrorState] = React.useState(false);
    const mnaHost = mnaUrlMap[window.sps.$Constants.env]
    const mnaWebEventUrl = `${mnaHost}/mna/events/v1/user-web-events`;
    let pollingTimeout;
    const getHttpConfig = token => {
        return {
            headers: {
                Authorization: `bearer ${token}`
            }
        };
    };
    const poll = interval => {
        const currentTime = new Date().toISOString();
        // we need to use a closure to ensure we have the newest token when a user logs out and logs back in
        pollingTimeout = setTimeout(
            (function (token) {
                return () => {
                    axios
                        .get(
                            `${
                            mnaUrlMap[window.sps.$Constants.env]
                            }/mna/events/v1/user-web-events/?target_user_id=${
                            $CurrentUser.id
                            }&events_newer=${currentTime}`,
                            getHttpConfig(token)
                        )
                        .then(resp => {
                            if (resp.data.results.length > 0) {
                                setWebNotifications(notifications => {
                                    return updateNotifications(resp.data.results, notifications);
                                });
                                // if there are existing unread messages, we want to add the new ones to that total
                                setUnreadMessages(prevUnreadMessages => {
                                    return prevUnreadMessages + resp.data.count;
                                });
                            }
                            // if no new events have been emitted since last interval, just reset timer
                            poll(interval);
                        })
                        .catch(e => {
                            setErrorState(true);
                            // if request fails, slow polling to 5 minute intervals
                            poll(EXTENDED_INTERVAL);
                        });
                };
            })($CurrentUser.token),
            interval
        );
    };
    const readMessages = () => {
        if (webNotifications.length > 0) {
            const body = {
                most_recent_seen: webNotifications[0].id
            };
            // to avoid a noticeable visual delay, we will zero out the unread messages first.
            // if the request happens to fail, the number will return on the next poll interval
            setUnreadMessages(0);
            axios
                .post(
                    `${mnaWebEventUrl}/unseen/${$CurrentUser.id}/`,
                    body,
                    getHttpConfig($CurrentUser.token)
                )
                .catch(e => {
                    console.error(e);
                });
        }
    };
    const fetchEvents = (page = 1, limit = 25) => {
        const fetchUrl = `${mnaWebEventUrl}/?target_user_id=${$CurrentUser.id}&page=${page}&limit=${limit}`;
        return axios
            .get(
                fetchUrl,
                getHttpConfig($CurrentUser.token)
            )
            .then(resp => {
                setWebNotifications(resp.data.results);
                return resp;
            })
            .catch(e => {
                setErrorState(true);
                return e;
            });
    };
    // updating notifications on
    // dropdown close event to ensure
    // interacted with stays up-to-date
    // without resetting infinite scrolling progress
    const updateWebEvents = () => {
        fetchEvents();
    }
    const markAllAsRead = async () => {
        /* Tell MNA to mark all of the user's notifications as read/interacted with */
        const url = `${mnaHost}/mna/events/v1/user-web-events/read/${$CurrentUser.id}/`;
        await axios.post(url, {}, getHttpConfig($CurrentUser.token));
        updateWebEvents();
    }
    // runs on event click
    const handleEventClick = mnaEvent => {
        const putBody = Object.assign({}, mnaEvent, { interacted_at: new Date() });
        return (
            axios
                .put(
                    `${mnaWebEventUrl}/${mnaEvent.id}/`,
                    putBody,
                    getHttpConfig($CurrentUser.token)
                )
                .catch(e => {
                    console.error(e);
                })
        );
    };
    // runs only on mount
    React.useEffect(() => {
        // register callback for login
        $CurrentUser.onLogin(() => {
            axios
                .get(
                    `${mnaWebEventUrl}/unseen/${$CurrentUser.id}/`,
                    getHttpConfig($CurrentUser.token)
                )
                .then(resp => {
                    setUnreadMessages(resp.data.unseen);
                })
                .catch(e => {
                    console.warn(e);
                });
            fetchEvents();
            poll(INTERVAL);
        }, true);
        // register callback for logout
        $CurrentUser.onLogout(() => {
            clearTimeout(pollingTimeout);
        }, true);
        return () => {
            clearTimeout(pollingTimeout);
        };
    }, []);
    return (
        <SpsNotificationDropdown
            notifications={webNotifications}
            readMessages={readMessages}
            unreadMessages={unreadMessages}
            error={errorState}
            eventClickFn={handleEventClick}
            fetchEventFn={fetchEvents}
            markAllReadFn={markAllAsRead}
            dropdownCloseFn={updateWebEvents}
            currentUser={$CurrentUser}
        />
    );
}
